import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {Box, ClickAwayListener, IconButton, ListItemIcon, MenuItem, MenuList, Paper, Popper, Typography} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ViewActiveIcon from "../../../assets/icons/view-active.png";
import DownloadIcon from "@mui/icons-material/Download";
import useReportLogs from "../../../hooks/useReportLogs";

const ActionPopperComponent = (props) => {

    const {report} = props;

    const navigate = useNavigate();
    const {downloadReportLogs} = useReportLogs();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    }

    const handleViewReport = (e, report) => {
        navigate("/reports/report-logs-list/details?reportId=" + report?.report_id)
    }

    const handleDownloadReport = (e, report) => {
        downloadReportLogs(report?.report_id, report?.report_type);
    }

      
    return (
        <Box onClick={handleClick}>
            <IconButton className="card-view">
                <MoreVertIcon aria-describedby={id} style={{cursor: "pointer", color: "#5959D8"}} />
            </IconButton>

            <Popper id={id} open={open} anchorEl={anchorEl}>
                <Paper style={{borderRadius: 2}} sx={{boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)"}}>
                    <ClickAwayListener onClickAway={handleClick}>
                        <MenuList>
                            <MenuItem style={{fontWeight: 500}} onClick={(e) => handleViewReport(e, report)}>
                                <ListItemIcon style={{padding: 0, minWidth: 30}}>
                                    <img alt="" src={ViewActiveIcon} style={{height: 18, width: 18}} /> 
                                </ListItemIcon>

                                <Typography variant="inherit" sx={{color: "#58565F", fontSize: 14}}>
                                    View
                                </Typography>
                            </MenuItem>

                            {(report?.report_status === "Completed") ?
                                <MenuItem style={{fontWeight: 500}} onClick={(e) => handleDownloadReport(e, report)}>
                                    <ListItemIcon style={{padding: 0, minWidth: 30}}>
                                        <DownloadIcon sx={{color: "#5959D8", height: 18, width: 18}} /> 
                                    </ListItemIcon>

                                    <Typography variant="inherit" sx={{color: "#58565F", fontSize: 14}}>
                                        Download
                                    </Typography>
                                </MenuItem>
                            :
                                null
                            }
                        </MenuList>
                    </ClickAwayListener>
                </Paper>
            </Popper>
        </Box>
    )
}

export default ActionPopperComponent